export function initSystemLogs() {
    console.log('[SystemLogs] Initializing System Logs module');

    // Attach click event to all view log buttons
    $(document).on('click', '.btn-view-log', function(e) {
        e.preventDefault();
        
        const url = $(this).data('url');
        
        if (!url) {
            console.error('[SystemLogs] No URL found on button');
            return;
        }

        // Optional: show loading state
        const $btn = $(this);
        const originalHtml = $btn.html();
        $btn.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>').prop('disabled', true);

        fetch(url)
            .then(response => response.json())
            .then(res => {
                $btn.html(originalHtml).prop('disabled', false);
                
                if(res.status === 'success') {
                    const log = res.data;
                    
                    let badgeClass = 'bg-secondary';
                    if(log.level === 'error') badgeClass = 'bg-danger';
                    if(log.level === 'critical') badgeClass = 'bg-dark';
                    if(log.level === 'emergency') badgeClass = 'bg-danger';
                    if(log.level === 'alert') badgeClass = 'bg-warning text-dark';
                    
                    document.getElementById('detailLevel').innerHTML = `<span class="badge ${badgeClass} text-uppercase">${log.level}</span>`;
                    document.getElementById('detailTime').textContent = log.created_at;
                    
                    let sourceIcon = 'bi-terminal';
                    if(log.source === 'mobile') sourceIcon = 'bi-phone';
                    if(log.source === 'web') sourceIcon = 'bi-laptop';
                    
                    const userDisplay = log.username ? log.username : 'Guest';
                    document.getElementById('detailSource').innerHTML = `<i class="bi ${sourceIcon} me-1"></i> ${log.source ? log.source.toUpperCase() : 'UNKNOWN'} (${userDisplay})`;
                    
                    document.getElementById('detailIp').textContent = log.ip_address || '-';
                    document.getElementById('detailMethod').textContent = log.request_method || '-';
                    document.getElementById('detailUrl').textContent = log.request_url || '-';
                    document.getElementById('detailMessage').textContent = log.message || '-';
                    document.getElementById('detailUserAgent').textContent = log.user_agent || '-';
                    
                    const modal = new bootstrap.Modal(document.getElementById('logDetailModal'));
                    modal.show();
                } else {
                    Swal.fire('Gagal', res.message || 'Gagal memuat detail log', 'error');
                }
            })
            .catch(err => {
                console.error(err);
                $btn.html(originalHtml).prop('disabled', false);
                Swal.fire('Error', 'Terjadi kesalahan saat memuat data log.', 'error');
            });
    });

    // Attach click event to clear logs button
    $(document).on('click', '#btn-clear-logs', function(e) {
        e.preventDefault();
        const url = $(this).attr('href');
        
        Swal.fire({
            title: 'Apakah Anda yakin?',
            text: "Ingin menghapus semua log? Tindakan ini tidak dapat dibatalkan.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Ya, Bersihkan!',
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.href = url;
            }
        });
    });
}
